import styled from 'styled-components'

export const BtnWrap = styled.div`
display: flex;
justify-content: flex-start;
`;
